import axios from 'utility/axios'
import {
	GET_PROPERTY,
	GET_PROPERTY_PROSPECT_DETAILS,
	GET_PROPERTY_DOCUMNETS,
	DELETE_PROPERTY_ATTACHMENT,
	POST_PROPERTY_ATTACHMENT,
	POST_CANCEL_PROPERTY,
	POST_CANCEL_PROPERTIES,
	POST_CAN_CANCEL_PROPERTY,
	POST_ADD_OR_RENEW_PROPERTIES,
	POST_FETCH_RENEWAL_PROPETIES,
} from 'utility/endpoints'
import getNested from 'utility/getNested'
import { formatPropertyMetaStatus, formatPropertySignupStatus } from 'utility/property'

export const fetchPropertyById = async ({ id }) => {
	const propCustData = await fetchPropertyDetailsById({ id })
	// htsData is old from DJ
	return {
		id,
		htsGroup: propCustData || null, // Ramesh
		meta: {
			signupState: formatPropertySignupStatus({
				data: propCustData,
				deadline: propCustData?.county?.countySignupDeadline,
			}),
			status: formatPropertyMetaStatus({ data: propCustData }),
		},
	}
}

export const postPropertyAttachment = async ({ attachmentType, file, id, year }) => {
	let baseData = {
		attachmentType,
		file,
		propertyId: id,
		taxYear: year,
	}
	var bodyFormData = new FormData()
	Object.keys(baseData).forEach((key) => {
		bodyFormData.append(key, baseData[key])
	})

	return await axios({
		method: 'post',
		url: POST_PROPERTY_ATTACHMENT,
		data: bodyFormData,
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}

export const fetchPropertyDataDetailsByid = async ({ id }) => {
	try {
		let url = `${GET_PROPERTY}/${id}`
		const res = await axios.get(url, {
			timeout: 100000000,
		})
		return getNested(res, 'data')
	} catch (err) {
		console.log('Error: ', err)
	}
}

export const fetchPropertyDetailsById = async ({ id }) => {
	try {
		if (!id) return null

		let url = `${GET_PROPERTY_PROSPECT_DETAILS}/${id}`

		const res = await axios.get(url, {
			timeout: 100000000,
		})
		return getNested(res, 'data')
	} catch (err) {
		console.log('Error: ', err)
	}
}

export const fetchPropertyDocuments = async ({ id, year }) => {
	if (!id || !year) return null
	try {
		let url = `${GET_PROPERTY_DOCUMNETS}/${id}/${year}`
		const res = await axios.get(url)
		return getNested(res, 'data')
	} catch (err) {
		console.log('Error fetching property documents: ', err)
	}
}

export const deletePropertyDocument = async ({ id }) => {
	if (!id) return null

	return await axios.delete(`${DELETE_PROPERTY_ATTACHMENT}/${id}`)
}

export const cancelProperty = async ({ id, reason, reasonDesc }) => {
	if (!id || !reason) {
		console.log('Missing required params for cancelProperty')
		throw new Error('Missing required params for cancelProperty')
	}

	const data = {
		propertyId: id,
		reason,
		reasonDesc,
	}

	return axios.post(POST_CANCEL_PROPERTY, data)
}

export const cancelProperties = async ({ propertyList, taxYearName, reason, reasonDesc }) => {
	if (!propertyList?.length || !reason) {
		console.log('Missing required params for cancelProperties')
		throw new Error('Missing required params for cancelProperties')
	}

	const data = {
		propertyList,
		taxYearName,
		reason,
		reasonDesc: reasonDesc || '',
	}

	return axios.post(POST_CANCEL_PROPERTIES, data)
}

export const canCancelProperty = async ({ id }) => {
	if (!id) {
		console.log('Missing required params for canCancelProperty')
		throw new Error('Missing required params for canCancelProperty')
	}

	const data = {
		propertyId: id,
	}

	try {
		const res = await axios.post(POST_CAN_CANCEL_PROPERTY, data)
		return res?.data
	} catch (err) {
		console.log('Error fetching can cancel status: ', err)
	}
}

export const postAddRenewProperties = async (data) => {
	const results = await axios.post(POST_ADD_OR_RENEW_PROPERTIES, data)
	return results?.data
}

export const postFetchRenewalProperties = async ({ groupId }) => {
	const results = await axios.post(POST_FETCH_RENEWAL_PROPETIES, {
		groupId,
	})
	return results?.data?.renewalProperties
}
